<template>
  <div style="overflow-x: auto">
    <table>
      <thead>
        <tr>
          <th>Key</th>
          <th>Description</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="(variable, index) in variables" :key="index">
          <td>
            <code>{{ variable.key }}</code>
          </td>
          <markdown tag="td" :html="variable.description" />
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue';
import { SnippetVariables } from '@bifrost-dev-docs-mfe/common/types/snippetVariables';
import Markdown from '@/components/markdown/Markdown.vue';

const props = defineProps({ encodedData: { type: String, required: true } });
const variables = computed(() => JSON.parse(decodeURIComponent(props.encodedData)) as SnippetVariables);
</script>
